import React from 'react'

export default function error() {
    return (
        <div>
            hello from error page
        </div>
    )
}
